import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    partData: [],
    metadataParts: {
        limit: 0,
        offset: 0,
        total: 0,
    },
}

const PartReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_PARTS:
            return {
                ...state,
                partData: action.payload.data,
                metadataParts: { ...action.payload.metadata },
            }

        default:
            return { ...state }
    }
}

export default PartReducer
